import _ from 'lodash';
import { put, takeLatest, select, call } from 'redux-saga/effects';
import {
  SUBMIT_RESET_PASSWORD,
  UPDATE_SUBMIT_LOADING,
} from '../actions/customerResetPasswordAction';
import { isApp, stringFormatter } from '../../../utils';
import { getCustomerProfilePasswordValue } from '../selectors/customerProfileResetPasswordSelectors';
import { getCustomerProfileResetApi } from '../selectors/customerProfileResetUsenameSelectors';
import { getLanguage } from '../../../selectors/userSelectors';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import uuidv4 from 'uuid/v4';
import { callBackErrorCodePage, returnErrorCode } from '../utils';
import {
  RESET_PASSWORD_FEATURE_ID,
  VERIFY_DISPLAY_ERROR_CODE_LIST,
} from '../constants/constants';
import { store } from '../../../stores';
import { DISPLAY_ERROR_CODE } from '../actions/changeContactAction';

function* submitResetPasswordData(payload?: any) {
  const { otp, callBack, defaultErrorCode } = _.get(payload, 'payload', {});
  try {
    yield put({ type: UPDATE_SUBMIT_LOADING, isSubmitLoading: true });
    const sendPassword = yield select(getCustomerProfilePasswordValue);
    const apiUrl = yield select(getCustomerProfileResetApi);
    const featureName = 'afterLoginforgotPassword';
    const platform = isApp() ? 'APP' : 'WEB';
    const language = yield select(getLanguage);
    // const res = { status: 200, json: () => require('../mock/customerResetUserName.json') }
    const url = stringFormatter(apiUrl, {
      featureName,
      platform,
      otp,
    });
    const res = yield call(
      myAxaFetchWithToken,
      url,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-axahk-msgid': uuidv4(),
        },
        body: JSON.stringify({
          password: sendPassword,
          locale: language.toUpperCase(),
        }),
      },
      undefined,
      undefined,
      0,
    );
    const data = yield res.json();
    const errorCode = _.get(data, 'response.reasonCode', '');
    handleErrorCode(
      errorCode,
      callBack,
      defaultErrorCode,
      RESET_PASSWORD_FEATURE_ID,
    );
    yield put({ type: UPDATE_SUBMIT_LOADING, isSubmitLoading: false });
  } catch (error) {
    yield put({ type: UPDATE_SUBMIT_LOADING, isSubmitLoading: false });
    if (error && error.json) {
      error.json().then((data: any) => {
        const errorCode = _.get(data, 'response.reasonCode', defaultErrorCode);
        handleErrorCode(
          errorCode,
          callBack,
          defaultErrorCode,
          RESET_PASSWORD_FEATURE_ID,
        );
      });
    } else {
      handleErrorCode(
        defaultErrorCode,
        callBack,
        defaultErrorCode,
        RESET_PASSWORD_FEATURE_ID,
      );
    }
  }
}

export function handleErrorCode(
  errorCode: string,
  callback: (...args: any[]) => any,
  defaultErrorCode: string,
  featureId: string,
) {
  if (_.isEmpty(errorCode) || errorCode === '200') {
    if (_.isFunction(callback)) {
      callback();
    }
  } else {
    const isDisplayError = VERIFY_DISPLAY_ERROR_CODE_LIST.includes(errorCode);
    if (isDisplayError) {
      store.dispatch({
        type: DISPLAY_ERROR_CODE,
        errorCode: errorCode,
      });
    } else {
      callBackErrorCodePage(
        featureId,
        returnErrorCode(errorCode, defaultErrorCode, featureId),
      );
    }
  }
}

function* customerResetPasswordSaga() {
  yield takeLatest(SUBMIT_RESET_PASSWORD, submitResetPasswordData);
}

export default customerResetPasswordSaga;
